import { Color, Font } from '../../style'

export const screenOptions = {
  headerShadowVisible: false,
  contentStyle: { backgroundColor: Color.simplyWhite },
  title: '',
  headerTintColor: Color.coffee,
  headerBackTitleStyle: {
    fontFamily: Font.medium,
    fontSize: 16,
  },
}
